// Module
var code = "<react-component name=\"ArchivedMemberships\"></react-component>\n";
// Exports
module.exports = code;